/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createRedmineConfig = /* GraphQL */ `
  mutation CreateRedmineConfig(
    $input: CreateRedmineConfigInput!
    $condition: ModelRedmineConfigConditionInput
  ) {
    createRedmineConfig(input: $input, condition: $condition) {
      id
      name
      redmineurl
      apikey
      taskListStatus {
        progress {
          id
          name
        }
        closed {
          id
          name
        }
      }
      owner
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const updateRedmineConfig = /* GraphQL */ `
  mutation UpdateRedmineConfig(
    $input: UpdateRedmineConfigInput!
    $condition: ModelRedmineConfigConditionInput
  ) {
    updateRedmineConfig(input: $input, condition: $condition) {
      id
      name
      redmineurl
      apikey
      taskListStatus {
        progress {
          id
          name
        }
        closed {
          id
          name
        }
      }
      owner
      timestamp
      createdAt
      updatedAt
    }
  }
`;
export const deleteRedmineConfig = /* GraphQL */ `
  mutation DeleteRedmineConfig(
    $input: DeleteRedmineConfigInput!
    $condition: ModelRedmineConfigConditionInput
  ) {
    deleteRedmineConfig(input: $input, condition: $condition) {
      id
      name
      redmineurl
      apikey
      taskListStatus {
        progress {
          id
          name
        }
        closed {
          id
          name
        }
      }
      owner
      timestamp
      createdAt
      updatedAt
    }
  }
`;
